import { render, staticRenderFns } from "./Froot_Wheel_Detail.vue?vue&type=template&id=8d4b856a&scoped=true"
import script from "./Froot_Wheel_Detail.vue?vue&type=script&lang=js"
export * from "./Froot_Wheel_Detail.vue?vue&type=script&lang=js"
import style0 from "./Froot_Wheel_Detail.vue?vue&type=style&index=0&id=8d4b856a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4b856a",
  null
  
)

export default component.exports